import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { ENT_SUPPLIER_LIST, ENT_SUPPLIER_DETAIL } from '../../actions';
import {
  EnterpriseSupplierListSuccess, EnterpriseSupplierListError,
  EnterpriseSupplierDetailSuccess, EnterpriseSupplierDetailError,
} from '../../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
    }, reject);
  });
}

const onListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'enterprise/supplier/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onDetailAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'enterprise/supplier/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

function* onList(data) {
  try { const response = yield call(onListAsync, data.payload); yield put(EnterpriseSupplierListSuccess(response.data)); }
  catch (error) { yield put(EnterpriseSupplierListError(error)); }
}

function* onDetail(data) {
  try { const response = yield call(onDetailAsync, data.payload); yield put(EnterpriseSupplierDetailSuccess(response.data.data)); }
  catch (error) { yield put(EnterpriseSupplierDetailError(error)); }
}

export function* watchList() { yield takeEvery(ENT_SUPPLIER_LIST, onList); }
export function* watchDetail() { yield takeEvery(ENT_SUPPLIER_DETAIL, onDetail); }

export default function* rootSaga() {
  yield all([fork(watchList), fork(watchDetail)]);
}
